import TeceoLogo from '@components/v2/ui/TeceoLogo/TeceoLogo';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { useEffect } from 'react';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';
import { Locales } from '../../translation/messages';
import { useNpsContext } from '../contexts/Nps.context';

const AUTO_CLOSE_MS = 10000;

const NpsThanksMessage = () => {
  const { translate, locale } = useTranslation();
  const { onClose } = useNpsContext();

  useEffect(() => {
    const timeout = setTimeout(onClose, AUTO_CLOSE_MS);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1.5, maxWidth: 320 }}>
      <TeceoLogo height={32} />
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
          {translate(LangEnum.NPS_THANKS_TEXT)}
        </Typography>
        {locale !== Locales.ENGLISH && (
          <Typography variant="body2" color="text.secondary">
            {translate(LangEnum.NPS_THANKS_SUB_TEXT)}
          </Typography>
        )}
      </Box>
    </Stack>
  );
};

export default NpsThanksMessage;
